import { createAsyncThunk } from "@reduxjs/toolkit";
import { getConnectionList, getUser, getUserDetail, statusManageUser } from "store/services/users";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All user
export const GetAllUserAction = createAsyncThunk(
  "user/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUser(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete user
export const StatusManageUserAction = createAsyncThunk(
  "user/statusManage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await statusManageUser(rest);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        const userPayload = { ...filter };

        if (filter.status === "all") {
          delete userPayload.status;
        }
        const responce = await getUser(userPayload);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Get user detail
export const GetUserDetailAction = createAsyncThunk(
  "user/detail",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserDetail(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetConnectionListAction = createAsyncThunk(
  "user/connection",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getConnectionList(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
